<template>
    <div>
        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="table.total_records"
            :isLoading.sync="table.isLoading" :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }" :columns="table.columns" :rows="table.rows">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                    <router-link :to="'/follow-up/template/edit?id=' + props.row.id" class="btn btn-primary text-white margin5">
                        Edit
                    </router-link>
                    <a v-on:click="deleteTemplate(props.row.id)" class="btn btn-danger text-white margin5">Hapus</a>
                </span>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            table: {
                isLoading: false,
                columns: [
                    { label: 'Judul', field: 'title', sortable: true },
                    { label: 'Pesan', field: 'message', sortable: false },
                    { label: 'Aksi', field: 'action', sortable: false }
                ],
                rows: [],
                total_records: 0,
                serverParams: {
                    page: 1,
                    limit: 10
                }
            }
        };
    },
    methods: {
        async loadItems() {
            this.table.isLoading = true;
            try {
                let response = await this.$store.dispatch("followup/followup_template_list", this.table.serverParams);
                this.table.rows = response.data.data.templates || [];
                this.table.total_records = response.data.data.total || 0;
            } catch (err) {
                this.$toast.error("Gagal memuat data");
            }
            this.table.isLoading = false;
        },
        async deleteTemplate(id) {
            if (confirm("Yakin ingin menghapus template ini?")) {
                try {
                    await this.$store.dispatch("followup/followup_template_delete", id);
                    this.$toast.success("Template berhasil dihapus");
                    this.loadItems();
                } catch (err) {
                    this.$toast.error("Gagal menghapus template");
                }
            }
        },
        onPageChange(params) {
            this.table.serverParams.page = params.currentPage;
            this.loadItems();
        },
        onPerPageChange(params) {
            this.table.serverParams.limit = params.currentPerPage;
            this.loadItems();
        },
        onSortChange() {
            this.loadItems();
        },
        onColumnFilter(params) {
            this.table.serverParams.columnFilters = params;
            this.loadItems();
        }
    },
    mounted() {
        this.loadItems();
    }
};
</script>

<style scoped>
.margin5 {
    margin: 2px;
}
</style>


